import { useStore } from 'effector-react'

import {
  $totalCountOfServiceList,
  getServiceList,
  serviceListMounted,
  $serviceList,
} from './model'
import { ServiceListRequest } from './types'

export const useServiceList = () => {
  const serviceList = useStore($serviceList)
  const loading = useStore(getServiceList.pending)
  const totalCountOfServiceList = useStore($totalCountOfServiceList)

  const onChangeServiceList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    filters,
  }: ServiceListRequest) => {
    serviceListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      filters,
    })
  }

  return {
    serviceList,
    totalCountOfServiceList,
    loading,
    onChangeServiceList,
  }
}
